// Ghost text: the rest of a suggested reply, drawn after what the agent typed in the composer.

// Quick responses are HTML; ghost text and suggestion cards show them as plain text, paragraphs as spaces.
export const htmlToPlain = html => new DOMParser()
  .parseFromString(String(html || '').replace(/<br\s*\/?>|<\/(p|div|li|h[1-6])>/gi, ' '), 'text/html')
  .body.textContent || '';

// Text compared for ghost text: single spaces, but a trailing space the agent typed still counts.
const comparable = text => text.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').replace(/^ /, '');

/**
 * The ghost text for the composer: in an empty one the best match, unless the agent already replied
 * to it; while the agent types, the rest of the first candidate that starts with what is typed.
 *
 * @param composerText what the composer holds, as plain text
 * @param candidates [{ item, text, bestMatch }], best first; text is the reply as it would be sent
 * @param dismissedId id of a best match that an empty composer no longer offers
 * @returns {{ item, rest }|null}
 */
export const findGhost = (composerText, candidates, dismissedId = null) => {
  const raw = (composerText || '').replace(/\n$/, '');
  // Several lines are the agent's own writing, and '/' opens the quick response search.
  if (raw.includes('\n') || raw.trim().startsWith('/')) {
    return null;
  }
  const typed = comparable(raw);
  const typedLower = typed.toLowerCase();
  for (const candidate of candidates) {
    if (!typed && (!candidate.bestMatch || candidate.item.id === dismissedId)) {
      continue;
    }
    const text = comparable(candidate.text).trim();
    if (text.length > typed.length && text.toLowerCase().startsWith(typedLower)) {
      return { item: candidate.item, rest: text.slice(typed.length) };
    }
  }
  return null;
};
